import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ForgotPasswordPage: React.FC = () => {
  const { requestPasswordReset } = useAuth();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      await requestPasswordReset(email);
      setSubmitted(true);
    } catch (err: any) {
      // Don't reveal if the email exists — always show success
      setSubmitted(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-form">
          <h2>Reset Password</h2>
          <p className="login-subtitle">
            Enter your email address and we'll send you a link to reset your password.
          </p>

          {submitted ? (
            <>
              <div style={{
                padding: '16px',
                backgroundColor: 'var(--delft-ice)',
                borderRadius: '8px',
                color: 'var(--charcoal)',
                fontSize: '0.875rem',
                marginBottom: '16px',
                textAlign: 'center',
              }}>
                If an account exists for <strong>{email}</strong>, a password reset email has been sent. Please check your inbox.
              </div>
              <div className="login-footer">
                <p><Link to="/login">Back to Login</Link></p>
              </div>
            </>
          ) : (
            <>
              {error && <div className="error-message">{error}</div>}

              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="email">Email</label>
                  <input
                    type="email"
                    id="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>

                <button type="submit" disabled={loading} className="login-btn" style={{ width: '100%' }}>
                  {loading ? 'Sending...' : 'Send Reset Link'}
                </button>
              </form>

              <div className="login-footer">
                <p><Link to="/login">Back to Login</Link></p>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
